module.exports = __webpack_public_path__ + "img/full3-min.78d0a748.png";